<script>
import InfoStats from '@/rex-components/rex-info-stats.vue';
import shortenLargeNumber from '@/utils/numberShortner';
import {
  CAPABILITY_ANALYTICS,
  CAPABILITY_LOG,
  CAPABILITY_DBM,
} from '@/utils/constants';
import { VIEW_SAVED_SEARCHES_TAB_KEY } from '@/components/Log/log.constants';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { getValidatedToolTip } from '@/utils/helper-function';
import { usePermissions } from '@/hooks/usePermissions';
import { HOME_RESOURCE_GROUP } from '@/router/constant';

export default {
  components: { InfoStats },
  props: {
    label: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('globalState/app', ['updateDashboard']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    metricInfoLabel() {
      return this.label?.header?.metricInfoLabel;
    },
    hasHomeWritePermission() {
      const { hasCapabilityWritePermission } = usePermissions();
      return hasCapabilityWritePermission(HOME_RESOURCE_GROUP);
    },
  },
  data() {
    return {
      labelValue: 0,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions('homeState', { getLabelDataAction: 'getLabelData' }),
    ...mapMutations('homeState', ['setdeleteWidgetId']),
    getValidatedToolTip,
    shortenLargeNumber,
    getIconName(capability) {
      return capability.toLowerCase() || '';
    },
    async getLabelData() {
      try {
        this.isLoading = true;
        let aggregatorType =
          !this.label.metricName[0]?.aggregatorType ||
          this.label.metricName[0]?.aggregatorType === null
            ? 'avg'
            : this.label.metricName[0]?.aggregatorType;
        aggregatorType = aggregatorType === 'sum' ? 'total' : aggregatorType;

        const params = {
          duration: this.getDurationTime,
          config: {
            queryMetricType: this.label.queryMetricType,
            metricName: this.label.metricName[0]?.metricName,
            entityType: this.label.entityType,
            serviceKey: this.label.serviceKey,
            capability: this.label.capability,
            chartType: this.label.chartType,
            widgetName: this.label.widgetName,
            isLatestValue: true,
            sort: 'DES',
            aggregatorType: aggregatorType,
          },
        };
        const resData = await this.getLabelDataAction(params);
        if (resData && resData[0])
          this.labelValue = resData[0].readMetricsValues[aggregatorType];
        else this.labelValue = 0;
        this.isLoading = false;
      } catch (error) {
        console.log('error', error);
        this.labelValue = 0;
        this.isLoading = false;
      }
    },
    deleteWidget() {
      this.setdeleteWidgetId(this.label.id);
    },
    onRedirect(capability) {
      switch (capability) {
        case CAPABILITY_LOG:
          this.$router.push({
            name: 'log',
            query: { currView: VIEW_SAVED_SEARCHES_TAB_KEY },
          });
          break;
        case CAPABILITY_ANALYTICS:
          this.$router.push({
            name: 'analytics',
            query: { currView: VIEW_SAVED_SEARCHES_TAB_KEY },
          });
          break;
        case CAPABILITY_DBM:
          this.$router.push({
            name: 'customQueryOverview',
          });
          break;
      }
    },
  },
  watch: {
    updateDashboard() {
      this.getLabelData();
    },
    getDurationTime() {
      this.getLabelData();
    },
  },
  mounted() {
    this.getLabelData();
  },
};
</script>

<template>
  <div>
    <div class="label-widget-container">
      <div class="label-widget-header">
        <span
          class="ellipsis"
          v-tooltip:top="getValidatedToolTip(label.widgetName, 15)"
        >
          {{ label.widgetName }}
        </span>
        <div>
          <span
            @click="() => onRedirect(label.capability)"
            class="redirect-status-icon"
          >
            <BaseIcon
              name="redirect"
              width=".9125rem"
              height=".9125rem"
              iconColor="rgb(245, 150, 0)"
            />
          </span>
          <span
            v-if="hasHomeWritePermission"
            @click="deleteWidget"
            class="delete-status-icon"
          >
            <BaseIcon name="deleteFilled" width=".9125rem" height=".9125rem" />
          </span>
        </div>
      </div>
      <InfoStats
        :textValue="shortenLargeNumber(labelValue)"
        :textLabel="metricInfoLabel"
        :iconName="getIconName(label.capability)"
        :iconStyle="{ fill: 'rgb(255, 255, 255)' }"
        iconHeight="2.5rem"
        iconWidth="2.5rem"
        :containerSyle="{
          width: '16rem',
          margin: '0rem',
          borderBottomRightRadius: '0.75rem',
          borderBottomLeftRadius: '0.75rem',
        }"
        :loading="isLoading"
        textLabelClass="grey"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.label-widget-container {
  display: flex;
  flex-direction: column;
  margin: 0.5rem;
}
.label-widget-header {
  @include flex-center-justify(space-between);
  padding: 0.4rem 1rem;
  background-color: $bg-dark-black;
  width: 16rem;
  border-bottom: 0.063rem solid $border-primary;
  border-top-right-radius: 0.75rem;
  border-top-left-radius: 0.75rem;
}
.redirect-status-icon {
  cursor: pointer;
  fill: $color-brand-accent;
  margin-right: 0.75rem;
}
.delete-status-icon {
  fill: $color-brand-accent;
  cursor: pointer;
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 10rem;
}
</style>
